import { convert } from "html-to-text";

export const descriptionSplitByPTag = (str) => {
  try {
    if (!str) {
      return [];
    }

    let outputArr = str.split("</p>");
    outputArr = outputArr.map((data) => data + "</p>");

    let finalArray = [];

    // helper to merge incomplete tag blocks (blockquote, table, etc.)
    const mergeUntilBalanced = (arr, startIndex, tagName) => {
      let openingCount =
        arr[startIndex].split(`<${tagName}`).length - 1;
      let closingCount =
        arr[startIndex].split(`</${tagName}>`).length - 1;

      if (openingCount !== closingCount) {
        let ind = startIndex;
        while (true) {
          startIndex++;
          arr[ind] = arr[ind] + arr[startIndex];

          const openingInternal =
            arr[startIndex]?.split(`<${tagName}`).length - 1;
          const closingInternal =
            arr[startIndex]?.split(`</${tagName}>`).length - 1;

          arr[startIndex] = "";

          openingCount += openingInternal;
          closingCount += closingInternal;

          if (openingCount === closingCount) {
            break;
          }
        }
      }
    };

    for (let x = 0; x < outputArr.length; x++) {
      if (!outputArr[x]) continue;

      // balance blockquotes
      mergeUntilBalanced(outputArr, x, "blockquote");

      // balance tables
      mergeUntilBalanced(outputArr, x, "table");
    }

    // cleanup empty entries
    for (let x = 0; x < outputArr.length; x++) {
      if (outputArr[x] && outputArr[x].length !== 0) {
        finalArray.push(outputArr[x]);
      }
    }

    return finalArray;
  } catch (error) {
    console.error(error);
    return [];
  }
};


export function splitHtmlByParagraph(htmlString) {
  // Regular expression to match content between <p> and </p> tags
  const regex = /<p>(.*?)<\/p>/g;

  // Array to hold the extracted paragraphs
  let paragraphs = [];

  // Extract paragraphs
  let match;
  while ((match = regex.exec(htmlString)) !== null) {
    paragraphs.push(match[1]);
  }

  return paragraphs;
}
export function splitHTMLArticle(articleHTML) {
  function findSubstringIndices(inputString, substring) {
    const indices = [];
    let index = inputString.indexOf(substring);

    while (index !== -1) {
      indices.push(index);
      index = inputString.indexOf(substring, index + 1);
    }

    return indices;
  }

  const inputString = articleHTML; //articleHtmlgoesHere
  const substring = "<p>";
  const substring1 = "</p>";

  const pOpening = findSubstringIndices(inputString, substring);
  const pClosing = findSubstringIndices(inputString, substring1);

  var finalArray = [];
  let sIndex = 0;
  if (pOpening[0] !== 0) {
    finalArray.push(inputString.substring(0, pOpening[0]));
  }
  finalArray.push(inputString.substring(pOpening[0], pClosing[0] + 4));
  sIndex++;
  while (sIndex < pOpening.length) {
    if (pClosing[sIndex - 1] + 4 !== pOpening[sIndex]) {
      const embedInBtw = inputString.substring(
        pClosing[sIndex - 1] + 4,
        pOpening[sIndex]
      );
      finalArray.push(embedInBtw);
    }
    const pTag = inputString.substring(pOpening[sIndex], pClosing[sIndex] + 4);
    finalArray.push(pTag);
    sIndex++;
  }
  return finalArray;
}

export function splitHTMLArticleMin(articleHTML) {
  // Remove unwanted amp tags + their parent divs
  function stripAmpEmbeds(html) {
    // Regex to remove <div>...</div> that contains amp-iframe, amp-twitter, or amp-youtube
    return html
      .replace(/<div[^>]*>\s*<amp-iframe[\s\S]*?<\/amp-iframe>\s*<\/div>/gi, "")
      .replace(/<div[^>]*>\s*<amp-twitter[\s\S]*?<\/amp-twitter>\s*<\/div>/gi, "")
      .replace(/<div[^>]*>\s*<amp-youtube[\s\S]*?<\/amp-youtube>\s*<\/div>/gi, "")
      // In case amp-* tags are not wrapped in a div
      .replace(/<amp-iframe[\s\S]*?<\/amp-iframe>/gi, "")
      .replace(/<amp-twitter[\s\S]*?<\/amp-twitter>/gi, "")
      .replace(/<amp-youtube[\s\S]*?<\/amp-youtube>/gi, "");
  }

  function findSubstringIndices(inputString, substring) {
    const indices = [];
    let index = inputString.indexOf(substring);

    while (index !== -1) {
      indices.push(index);
      index = inputString.indexOf(substring, index + 1);
    }

    return indices;
  }

  const inputString = stripAmpEmbeds(articleHTML);
  const substring = "<p>";
  const substring1 = "</p>";

  const pOpening = findSubstringIndices(inputString, substring);
  const pClosing = findSubstringIndices(inputString, substring1);

  var finalArray = [];
  let sIndex = 0;

  if (pOpening[0] !== 0) {
    finalArray.push(inputString.substring(0, pOpening[0]));
  }

  if (pOpening.length > 0 && pClosing.length > 0) {
    finalArray.push(inputString.substring(pOpening[0], pClosing[0] + 4));
    sIndex++;
  }

  while (sIndex < pOpening.length) {
    if (pClosing[sIndex - 1] + 4 !== pOpening[sIndex]) {
      const embedInBtw = inputString.substring(
        pClosing[sIndex - 1] + 4,
        pOpening[sIndex]
      );
      finalArray.push(embedInBtw);
    }
    const pTag = inputString.substring(pOpening[sIndex], pClosing[sIndex] + 4);
    finalArray.push(pTag);
    sIndex++;
  }

  return finalArray;
}

export function getPlainText(htmlText) {
  try {
    const plainText = convert(htmlText, {
      wordwrap: false, // Disable word wrapping
      ignoreImage: true, // Ignore images
      preserveNewlines: true, // Preserve newlines
      uppercaseHeadings: false, // Do not convert headings to uppercase
    });
    return plainText;
  } catch (err) {
    console.log("err while converting to plain text", err);
    return htmlText;
  }
}

export function capitalizeWords(str) {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
